export interface TransactionGlLine {
	period: string;
	date: string;
	/** GL account name */
	account: string;
	accountcode?: string;
	description: string;
	debit: number;
	credit: number;
	posted: string;
}

export function normalizeTransactionGlLines(raw: unknown): TransactionGlLine[] {
	if (!Array.isArray(raw)) {
		return [];
	}
	return raw.map((row: any) => ({
		period: row?.period != null ? String(row.period) : '',
		date: row?.date != null ? String(row.date) : '',
		account: row?.account != null ? String(row.account) : '',
		accountcode: row?.accountcode != null ? String(row.accountcode) : '',
		description: row?.description != null ? String(row.description) : '',
		debit: Number(row?.debit) || 0,
		credit: Number(row?.credit) || 0,
		posted: row?.posted != null ? String(row.posted) : '',
	}));
}
